import React, { useState, useEffect } from 'react';
import './Reviews.css';

interface Review {
  quote: string;
  reviewer: string;
  description: string;
}

const reviews: Review[] = [
  { quote: "Home Temple are reliable, hard workers and very knowledgeable. They complete all they are asked to do and leave the area neat and tidy.", reviewer: "Alan M.", description: "Resident, Spearwood" },
  { quote: "We love what Home Temple are doing!", reviewer: "David", description: "Property Manager, VPG" },
  { quote: "Very polite, friendly, great attention to detail. Quality work. Home Temple know how to use home maintenance and garden equipment well. I didn't really have to explain much which is very helpful when managing a chronic illness. Will be booking Home Temple again.", reviewer: "Jodee", description: "Resident, Kardinia" },
  { quote: "Home Temple were great, professional, polite and efficient. We had new turf laid and it was the first time for mowing and he did a fabulous job. Would definitely get him back again and recommend him.", reviewer: "Marney", description: "Resident, White Gum Valley" },
  { quote: "Fantastic job, friendly service and helpful advice thoroughly recommend Home Temple. Thank you ☺️", reviewer: "Bec", description: "Resident, Hamilton Hill" }
];

const Reviews: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState<'left' | 'right' | null>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 12000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const goToNext = () => {
    setDirection('right');
    setTimeout(() => setCurrentIndex((prev) => (prev + 1) % reviews.length), 0);
  };

  const goToPrev = () => {
    setDirection('left');
    setTimeout(() => setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length), 0);
  };

  const goToReview = (index: number) => {
    setDirection(index > currentIndex ? 'right' : 'left');
    setTimeout(() => setCurrentIndex(index), 0);
  };

  useEffect(() => {
    if (direction) {
      const timer = setTimeout(() => setDirection(null), 500);
      return () => clearTimeout(timer);
    }
  }, [currentIndex, direction]);

  return (
    <section className="reviews">
      <div className="textbox">
        <h1 className="reviews-title">Customer Reviews</h1>
      </div>
      <div className="textbox reviews-textbox">
        <div className="reviews-container">
          <button className="reviews-arrow reviews-arrow-left" onClick={goToPrev}>
            ‹
          </button>
          <div className="reviews-slider">
            <div
              key={currentIndex}
              className={`reviews-quote-container ${direction ? `slide-${direction}` : ''}`}
            >
              <div className="reviews-quote">
                <p>"{reviews[currentIndex].quote}"</p>
              </div>
            </div>
          </div>
          <button className="reviews-arrow reviews-arrow-right" onClick={goToNext}>
            ›
          </button>
          <div className="reviews-static-content">
            <p className="reviews-subtitle">{reviews[currentIndex].reviewer}</p>
            <p className="reviews-description">{reviews[currentIndex].description}</p>
            <div className="reviews-bullets">
              {reviews.map((_, index) => (
                <span
                  key={index}
                  className={`reviews-bullet ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => goToReview(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;